import mqtt, { MqttClient, IClientOptions } from "mqtt";


export default class MQTTClient {
  private client: MqttClient | null = null;
  private readonly url: string;
  private username:string;
  private password:string;
  private isConnected = false;

  constructor(url: string, username:string, password:string) {
    console.log("this.url=",this.url)
    this.url = url;
   this.username = username;
   this.password = password;
  }

  connect( handler: (topic: string, message: string) => void, onConnect?: () => void, onError?: (err: any) => void): Promise<void> {
    return new Promise((resolve, reject) => {

      let clientid =  localStorage.getItem('clientid')
      if (clientid==null)
        clientid = 'TSWEB_' + Math.random().toString(16).slice(2, 8);
      const options: IClientOptions = { 
        clean: true,
        reconnectPeriod: 2000,
        connectTimeout: 4000,
        clientId:clientid,
        username:this.username,
        password:this.password
      };
      console.log("this.url:"+this.url)
      this.client = mqtt.connect(this.url, options);

      this.client.on("connect", () => {
        this.isConnected = true;
        console.log(`[MQTTClient] Connected to ${this.url}`);
        onConnect?.();
        resolve();
      });

      this.client.on("error", (err) => {
        console.error("[MQTTClient] Error:", err.message);
        this.isConnected = false;
        onError?.(err);
        resolve()
       // reject(err);
      });

      this.client.on("reconnect", () => {
        console.log("[MQTTClient] Reconnecting...");
      });

      this.client.on("close", () => {
        this.isConnected = false;
        console.warn("[MQTTClient] Connection closed.");
      });
       this.client.on("message", (t, msg) => {
        handler(t, msg.toString());
       });
    });
  }

  subscribe(topic: string) {
    if (!this.client) throw new Error("MQTT not connected");
    if (topic==null) return;
     const topicsArray = topic
        .split(',')
        .map(topic => topic.trim())
        .filter(topic => topic.length > 0);
    console.log(topicsArray)
    this.client.subscribe(topicsArray);
  }
 
  unsubscribe(topic:string){
    if (!this.client) throw new Error("MQTT not connected");
    if (topic==null) return;
     const topicsArray = topic
        .split(',')
        .map(topic => topic.trim())
        .filter(topic => topic.length > 0);
    this.client.unsubscribe(topicsArray)
  }

  publish(topic: string, payload: any) {
    if (!this.client) throw new Error("MQTT not connected");
    const data = typeof payload === "string" ? payload : JSON.stringify(payload);
    this.client.publish(topic, data);
  }

  disconnect() {
    if (this.client && this.isConnected) {
      this.client.end(true, () => {
        console.log("[MQTTClient] Disconnected.");
      });
    }
  }

  getClient(): MqttClient | null {
    return this.client;
  }
}
